import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[inputMaxLength]',
})
export class MaxLengthDirective implements OnInit {
  @Input('inputMaxLength') maxLength = 0;

  private counterEl!: HTMLElement;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private ngControl: NgControl
  ) {}

  ngOnInit(): void {
    // create counter element
    this.counterEl = this.renderer.createElement('span');
    this.renderer.setStyle(this.counterEl, 'position', 'absolute');
    this.renderer.setStyle(this.counterEl, 'bottom', '6px');
    this.renderer.setStyle(this.counterEl, 'right', '10px');
    this.renderer.setStyle(this.counterEl, 'fontSize', '12px');
    this.renderer.setStyle(this.counterEl, 'color', '#d4d4d4');
    this.renderer.setStyle(this.counterEl, 'pointerEvents', 'none');

    // wrap host element in relative container
    const parent = this.renderer.parentNode(this.el.nativeElement);
    const wrapper = this.renderer.createElement('div');
    this.renderer.setStyle(wrapper, 'position', 'relative');
    this.renderer.setStyle(wrapper, 'display', 'inline-block');
    this.renderer.setStyle(wrapper, 'width', '100%');
    this.renderer.insertBefore(parent, wrapper, this.el.nativeElement);

    this.renderer.removeChild(parent, this.el.nativeElement);
    this.renderer.appendChild(wrapper, this.el.nativeElement);
    this.renderer.appendChild(wrapper, this.counterEl);

    // add padding so text doesn't overlap with counter
    this.renderer.setStyle(this.el.nativeElement, 'padding-right', '60px');

    this.updateCounter();
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement | HTMLTextAreaElement;
    let value = input.value;

    // restrict length
    if (this.maxLength && value.length > this.maxLength) {
      value = value.substring(0, this.maxLength);
      input.value = value;

      if (this.ngControl && this.ngControl.control) {
        this.ngControl.control.setValue(value, { emitEvent: false });
      }
    }

    this.updateCounter();
  }

  private updateCounter(): void {
    const value = this.el.nativeElement.value || '';
    this.counterEl.innerText = `${value.length}/${this.maxLength}`;
  }
}
